import { adminHttpClient } from '../commons/adminHttpClient'

const isUserLastPrimaryAdmin = (companyUserId: string): Promise<boolean> =>
  adminHttpClient.get('/Companies/IsLastPrimaryAdmin', { companyUserId })

export default isUserLastPrimaryAdmin
